import { DateTime } from 'luxon'
import memoize from 'lodash/memoize'

let memoizedFormat = memoize(
  (style, date, dropZeros) => {
    let formatter = DateFormatter.formats[style]
    let zonedDate = null

    if (!formatter) {
      throw new Error(`Cannot find formatter for style: "${style}"!`)
    }

    if (date.isLuxonDateTime) {
      zonedDate = date
    } else if (date instanceof Date) {
      zonedDate = DateTime.fromJSDate(date, { zone: 'America/Chicago' })
    } else {
      zonedDate = DateTime.fromISO(date, { zone: 'America/Chicago' })
    }

    if (dropZeros && zonedDate.minute === 0) {
      // we drop zeros when dropZeros is true by setting to timeShort format
      formatter = DateFormatter.formats.timeShort
    }

    return zonedDate.toFormat(formatter)
  },
  (style, date) => `${style}::${date.valueOf()}`
)

const DateFormatter = {
  formats: {
    dashed: 'yyyy-LL-dd', // 2019-05-22
    slashed: 'LL/dd/yyyy', // 11/13/21
    full: 'DDD', // December 3, 2018
    fancyFull: 'DDDD', // Monday, December 3, 2018
    fullDay: 'EEEE, MMMM d', // Monday, December 3
    weekDay: 'EEE.', // Mon.
    dayOfMonth: 'd', // 3
    dayMonth: 'EEEE, MMMM', // Monday, December
    shortMonth: 'LLL', // Dec
    longMonth: 'MMMM', // December
    year: 'yyyy', // 2018
    time: 'h:mm a', // 8:00 AM
    timeShort: 'h a', // 8 AM
    timeSimple: 'h:mm', // 8:00
    minutes: 'mm:ss', // 10:30
    timeMeridian: 'a', // AM
    iso8601: "yyyy-LL-dd'T'hh:mm:ss'Z'", // 1990-05-30T08:33:00Z
    param: 'yyyy-LL-dd', // alias of the above
    machineTime: 'hh:mm:ss', // 08:00:00
    monthYear: 'MMMM yyyy' // December 2019
  },

  format: memoizedFormat
}

Object.keys(DateFormatter.formats).forEach(format => {
  Object.defineProperty(DateFormatter, format, {
    value: function (date, dropZeros = false) {
      return DateFormatter.format(format, date, dropZeros)
    }
  })
})

export default DateFormatter
